const isRealCategory = (category) =>
  typeof category === 'string' && category.trim() !== '' && category !== 'NONE';

// Same test ServicesStep uses to keep a service when saving: both category and name are filled in.
const isCompleteService = (service) =>
  typeof service?.category === 'string' && service.category.trim() !== '' &&
  typeof service?.name === 'string' && service.name.trim() !== '';

// Picks the category whose studio-rental question should be asked during registration.
// Candidates are only the distinct categories of services that are complete (a non-blank
// category and name), so the question appears once a service in that category is added,
// not from categoryType alone. If categoryType is one of those candidates it goes first;
// the rest keep service order. Returns the first candidate whose config has the prompt
// enabled with a non-blank message, otherwise null.
export const getStudioRentalPrompt = (provider, configs) => {
  if (!Array.isArray(configs) || configs.length === 0) {
    return null;
  }

  const candidates = [];
  (provider?.servicesProvided || []).forEach((service) => {
    if (isCompleteService(service) && !candidates.includes(service.category)) {
      candidates.push(service.category);
    }
  });

  const mainCategory = provider?.categoryType;
  const ordered = isRealCategory(mainCategory) && candidates.includes(mainCategory)
    ? [mainCategory, ...candidates.filter((category) => category !== mainCategory)]
    : candidates;

  for (const category of ordered) {
    const config = configs.find((c) => c && c.key === category);
    const message = typeof config?.studioRentalPromptMessage === 'string'
      ? config.studioRentalPromptMessage.trim()
      : '';
    if (config?.studioRentalPromptEnabled === true && message) {
      return { category, message };
    }
  }

  return null;
};
